'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAttachmentUploadUrlClient = undefined;

var _noAuthApiClient = require('../../http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATTACHMENT_UPLOAD_URL_PATH = 'messages/v2/attachment/public/upload-url';

var fetchAttachmentUploadUrlClient = exports.fetchAttachmentUploadUrlClient = function fetchAttachmentUploadUrlClient(_ref) {
  var sessionId = _ref.sessionId;

  return _noAuthApiClient2.default.get(ATTACHMENT_UPLOAD_URL_PATH, {
    query: {
      sessionId: sessionId
    }
  });
};


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/clients/fetchAttachmentUploadUrlClient.js
// module id = 656
// module chunks = 2 3